/**
 * key : 'VUE_APP_COMPANY_ID'
 *  - router
 *    - model [一个页面可能存在多个COMPONENTS] 对应 SpComponent 组件 的 myName 属性 以及对应的 handle;
 */
import innisfree from './innisfree/config'
import dreamW from './DW/config'

export const COMPONENTS_ROUTER_LIST = {
  '777': innisfree,
  '666': dreamW
}
